import { call } from "redux-saga/effects";

import { User } from "../../types/auth";
import analytics from "../../lib/Analytics";
import { applySagaError } from "./applySagaError";

/**
 * Identify user for analytics tracking.
 * With Simplified ID Merge enabled in Mixpanel, calling identify() automatically
 * links the anonymous $device_id with the user.id - no alias() needed.
 */
export function* identifyUserSaga(user: User, brand?: string) {
  try {
  let firstName = "";
  let lastName = "";

  if (user.user_metadata.full_name) {
    const nameParts = user.user_metadata.full_name.split(" ");
    firstName = nameParts[0] || "";
    lastName = nameParts.slice(1).join(" ") || "";
  } else {
    firstName = user.user_metadata.first_name || "";
    lastName = user.user_metadata.last_name || "";
  }

  yield call(() => {
    analytics.identify(user.id, {
      email: user.email,
      first_name: firstName,
      last_name: lastName,
        ...(brand && { brand }),
      });
    });
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "utils.identifyUserSaga",
      notifyUser: false,
    });
  }
}
